import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useUniqueId from "./useUniqueId";

export interface CopyToClipboardProps {
    value: string;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = props => {

    const [isCopied, setIsCopied] = useState(false);
    const componentId = useUniqueId();
    
    function onClick() {
        navigator.clipboard.writeText(props.value);
        setIsCopied(true);
    }

    return <OverlayTrigger 
                overlay={<Tooltip id={`tooltip-${componentId}`}>{isCopied ? "Copied!" : "Copy to clipboard"}</Tooltip>}
                onExited={() => setIsCopied(false)}
            >
        <button className="btn btn-link">
            <i className="material-icons" onClick={onClick}>content_copy</i>
        </button>
    </OverlayTrigger> 
}

export default CopyToClipboard;